import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import {
    showMemberLoader,
    onSaveMember,
    onMemberClose,
} from 'actions/member';
import { inputFields, displayedImage, showErrors, modalHeader, isFormValid, getFormError } from '../common';

const MemberAdd = () => {
    const dispatch = useDispatch();
    const addMemberState = useSelector(state => state.members.addMemberState);
    const [selectedMember, setSelectedMember] = useState(initProps);
    const [formErrors, setFormErrors] = useState({ name: '' });
    const [formValid, setFormValid] = useState(false);

    useEffect(() => {
        setSelectedMember(initProps());
    }, [addMemberState]);

    // using selectedMember makes it behave like componentDidUpdate - effect takes place when selectedMember changes
    useEffect(() => {
        setFormValid(false);
        validateForm();
    }, [selectedMember]);

    const initProps = () => {
        return {
            id: '',
            orgid: '',
            name: '',
            description: '',
            starred: false,
            frequently: false,
        };
    };

    const handleUserInput = (event, isNumber) => {
        const name = event.target.name;
        let value = event.target.value;
        if (isNumber) {
            value = Number(event.target.value);
        }
        updateSelectedMemberField(name, value);
        validateField(name, value);
    };

    const updateSelectedMemberField = (fieldName, value) => {
        const newMember = { ...selectedMember };
        newMember[fieldName] = value;
        setSelectedMember(newMember);
    };

    const validateField = (fieldName, value) => {
        formErrors[fieldName] = getFormError(fieldName, value);
        setFormErrors(formErrors);
        validateForm();
    };

    const validateForm = () => {
        setFormValid(isFormValid(selectedMember));
    };


    const maintainButton = (label) => {
        return (
            <Button className="text-uppercase" disabled={!formValid} color="primary" onClick={() => {
                dispatch(showMemberLoader());
                dispatch(onMemberClose());
                dispatch(onSaveMember(selectedMember));
                setSelectedMember(initProps());
                setFormValid(false);
            }}>
                {label}
            </Button>
        );
    };

    const modalHeaderOnClick = () => {
        return () => {
            setFormValid(false);
            dispatch(onMemberClose());
        };
    };

    const modalBody = (buttonText) => {
        return (
            <Fragment>
                <div className="modal-box-content">
                    <div className="row no-gutters">
                        {displayedImage(selectedMember)}
                        {showErrors(formErrors)}
                        {inputFields(selectedMember, handleUserInput)}
                    </div>
                </div>

                <div className="modal-box-footer d-flex flex-row">
                    {maintainButton(buttonText)}
                </div>
            </Fragment>
        );
    };
    
    return (
        <Modal className="modal-box" isOpen={addMemberState}>
            {modalHeader(<IntlMessages id="member.addMember" />, modalHeaderOnClick)}
            {modalBody(<IntlMessages id="member.addMember" />)}
        </Modal>
    );
};

export default MemberAdd;


// WEBPACK FOOTER //
// ./components/Agile/member/memberMaintenance/memberAdd/index.js